import { merge } from 'lodash'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import './reset.css'

Vue.config.productionTip = false

if (process.env.NODE_ENV !== 'production') require('@/__INITIAL_STATE__').default()

if (window.__INITIAL_STATE__) {
  store.replaceState(merge(store.state, window.__INITIAL_STATE__))
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
